<template>
  <div class="form">
    <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    <h1 align="center" style="text-decoration: underline overline">
      PERBELANJAAN DAN PEMBAYARAN LAIN OLEH ISI RUMAH
    </h1>

    <v-text-field
      outlined
      dense
      rounded
      v-model="HID"
      label="HID"
      width="20px"
      disabled
    ></v-text-field>

      
    <!-- DATATABLE  -->
    <v-card>
      <v-card-title>
        Senarai
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

         <v-spacer></v-spacer>
          <v-btn
          color="error"
          small
          @click="dialogPengesahan=true;"
          >
            Padam
          </v-btn>

      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataPerbelanjaan"
        :search="search"
        class="ml-3 mr-3"
        @click:row="handleClick"
        :footer-props="{ 'items-per-page-options': [3, 15, 30, 50, 100, -1] }"
      ></v-data-table>
    </v-card>




    <v-card>
      <v-card-title>
        <strong>[A] PERBELANJAAN ISI RUMAH SEBULAN </strong><br />
      </v-card-title>

    <v-form ref="form" v-model="valid" lazy-validation :disabled="disabledInput">
      <v-card-text>
          <!-- S187 -->
          <v-row>
            <!-- * Sekiranya S2 adalah Ketua isi rumah -->
            <v-col>
              S187 Anggarkan jumlah perbelanjaan anda dan ahli isi rumah dalam
              sebulan<br />
            </v-col> </v-row>
      </v-card-text>

      <v-card-text>
        <div>
          <!-- <input type="text" class="form-control" v-model="input.name"> -->
          <v-row>
            <v-col cols="1"><strong> Kod </strong> </v-col>

            <v-col cols="3"><strong> Kumpulan Perbelanjaan</strong> </v-col>

            <v-col cols="2"><strong> Jumlah (A) (RM) </strong> </v-col></v-row
          >

          <v-row>
            <v-col cols="1">
              <td>01</td>
            </v-col>

            <v-col cols="3"> Makanan dan minuman </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A01"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>02</td>
            </v-col>

            <v-col cols="3"> Minuman alkohol dan tembakau </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A02"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>03</td>
            </v-col>

            <v-col cols="3"> Pakaian dan kasut </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A03"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>04</td>
            </v-col>

            <v-col cols="3">
              Perumahan, air, elektrik, gas dan bahan api lain
            </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A04"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>05</td>
            </v-col>

            <v-col cols="3">
              Hiasan, perkakas dan penyelenggaraan isi rumah
            </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A05"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>06</td>
            </v-col>

            <v-col cols="3"> Kesihatan </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A06"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>07</td>
            </v-col>

            <v-col cols="3"> Pengangkutan </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A07"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>08</td>
            </v-col>

            <v-col cols="3"> Maklumat dan komunikasi </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A08"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>09</td>
            </v-col>

            <v-col cols="3"> Rekreasi, sukan dan kebudayaan </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A09"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>10</td>
            </v-col>

            <v-col cols="3"> Perkhidmatan pendidikan </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A10"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>11</td>
            </v-col>

            <v-col cols="3"> Restoran dan perkhidmatan penginapan </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A11"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>12</td>
            </v-col>

            <v-col cols="3"> Insurans dan perkhidmatan kewangan </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A12"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>13</td>
            </v-col>

            <v-col cols="3">
              Penjagaan diri, perlindungan sosial dan pelbagai barangan dan
              perkhidmatan
            </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A13"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td>90</td>
            </v-col>

            <v-col cols="3">
              Perbelanjaan bukan penggunaan isi rumah
            </v-col>
            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="A90"
                label="RM"
                required
                maxlength="7"
                min="0"
                @keypress="isNumber($event)"
              ></v-text-field> </v-col
          ></v-row>

          <v-row>
            <v-col cols="1">
              <td></td>
            </v-col>

            <v-col cols="3">
              <strong> KESELURUHAN JUMLAH (A) (RM) </strong>
            </v-col>

            <v-col cols="2">
              <v-text-field
                outlined
                dense
                v-model="jumBelanjaA"
                label="RM"
                required
                type="number"
                min="0"
                disabled
              ></v-text-field> </v-col
          ></v-row></div
      ></v-card-text>
     </v-form>

      <v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updatePERBELANJAAN()"
    >
      Kemaskini
    </v-btn>
</v-card-actions>


    </v-card>

    <v-alert prominent type="error" :value="popUpALert">
      <v-row align="center" class="mb-2">
        <v-col class="grow"> Adakah anda pasti untuk padam? </v-col>
        <v-col class="shrink">
          <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
          <v-btn @click="padam('2')">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <!-- Error Dialog -->
    <v-dialog v-model="errorDialog" width="500" height="200">
      <v-card>
        <v-alert dense outlined color="#C51162" type="error">
          <strong>{{ errMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Success Dialog -->
    <v-dialog v-model="successDialog" width="500" height="200">
      <v-card color="success">
        <v-alert dense outlined color="#C51162" type="success">
          <strong>{{ successMessage }}</strong>
        </v-alert>
      </v-card>
    </v-dialog>

    <!-- Pengesahan Padam Dialog -->
    <v-row justify="center">
        <v-dialog
          v-model="dialogPengesahan"
          persistent
          max-width="330"
        >
          <v-card>
            <v-card-text>
            <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
            {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
            <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
            </v-card-text>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="warning"
                @click="dialogPengesahan = false;"
              >
              {{$t('batal')}}
              </v-btn>
              <v-btn
                color="error"
                @click="padamData()"
              >
                {{$t('padam')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

  </div>
</template>
<script>
import axios from "axios";

//////////////////////////import services///////////////////
import getLocalStorage from "@/services/getLocalStorage";
const localStorageData = new getLocalStorage();

import lookupField from "@/services/lookupField";
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
  props: ["data"],
  async beforeMount() {
    var dataHID = localStorageData.getHIDdata();

    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB = dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.Bulan = dataHID.BULAN;
    this.Tahun = dataHID.TAHUN;

    this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
    this.NOAIR = this.currNOAIRData.NOAIR;
    this.getData(); //dapatkan data based on HID
  },
  setup() {},
  data: () => ({
    updateButton: true,
    saveButton: false,
    dialog: false,
    successDialog: false,
    errorDialog: false,
    successMessage: "",
    errMessage: "",
    message: "Saving Data",
    popUpALert: false,
    search: "",
    butangSimpan: true,
    butangKemaskini: false,
    disabledInput : false,
    dialogPengesahan: false,
    /////////////////////data declaration//////////////////////////
    HID: 0,
    A01: 0,
    A02: 0,
    A03: 0,
    A04: 0,
    A05: 0,
    A06: 0,
    A07: 0,
    A08: 0,
    A09: 0,
    A10: 0,
    A11: 0,
    A12: 0,
    A13: 0,
    A90: 0,

    dataPerbelanjaan: [],

    headers: [
      {
        text: "NOAIR",
        align: "start",
        sortable: false,
        value: "NOAIR",
      },
      { text: "HID", value: "HID" },
      { text: "A01", value: "A01" },
      { text: "A02", value: "A02" },
      { text: "A03", value: "A03" },
      { text: "A04", value: "A04" },
      { text: "A05", value: "A05" },
      { text: "A06", value: "A06" },
      { text: "A07", value: "A07" },
      { text: "A08", value: "A08" },
      { text: "A09", value: "A09" },
      { text: "A10", value: "A10" },
      { text: "A11", value: "A11" },
      { text: "A12", value: "A12" },
      { text: "A13", value: "A13" },
      { text: "A90", value: "A90" },
      { text: "Jumlah Perbelanjaan", value: "jumBelanjaA" },
    ],
    ///////////link untuk ke page/////////////////////
    breadcrumbs: [
      {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
      },
      {
        text: "Perbelanjaan (Sebulan)",
        disabled: true,
        href: "PERBELANJAAN",
      },
    ],
    
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    rules: {
      required: (v) => !!v || "field is required",
      emel: (value) => {
        return /.+@.+\..+/.test(value) || "E-mail must be valid";
      },
      percentage: (value) => {
        return value <= 100 || "Percentage must between 1 - 100";
      },
      takmauPoint: (value) => {
        return value % 1 === 0 ? true : "No point needed";
      },
    },
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
  }),

  methods: {
    getUnits: function (a) {
      alert(`${a}`);
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async simpan() {
      
      if (this.$refs.form.validate()) {
        this.dialog = true;
        setTimeout(() => (this.dialog = false), 2000);
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/JR5/PERBELANJAAN`,
            {
              HID: this.HID,
              NOAIR: this.NOAIR,
              A01: this.A01,
              A02: this.A02,
              A03: this.A03,
              A04: this.A04,
              A05: this.A05,
              A06: this.A06,
              A07: this.A07,
              A08: this.A08,
              A09: this.A09,
              A10: this.A10,
              A11: this.A11,
              A12: this.A12,
              A13: this.A13,
              A90: this.A90,
              jumBelanjaA: this.jumBelanjaA,
            }
          );
          this.res = res.data;
          this.successDialog = true;
          setTimeout(() => (this.successDialog = false), 2000);
          this.successMessage = "Data Disimpan!";
          this.reset();
          this.getData();
          setTimeout(() => this.goTo(), 1000);
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Simpan : " + error;
        }
      } else {
        window.scrollTo(0, 0);
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "Please fill in the field!";
      }
    },

    async updatePERBELANJAAN(){
            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/updatePERBELANJAAN`, {
                
              HID: this.HID,
              NOAIR: this.NOAIR,
              A01: this.A01,
              A02: this.A02,
              A03: this.A03,
              A04: this.A04,
              A05: this.A05,
              A06: this.A06,
              A07: this.A07,
              A08: this.A08,
              A09: this.A09,
              A10: this.A10,
              A11: this.A11,
              A12: this.A12,
              A13: this.A13,
              A90: this.A90,
              jumBelanjaA: this.jumBelanjaA,

              })
                this.res = res.data;
                this.butangKemaskini = false;
                this.successDialog = true;
                this.getData()
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Disimpan!';
                this.reset();
                setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }

        
      },

    async padam(val) {
      if (val == 0) {
        this.popUpALert = true;
      } else if (val == 1) {
        try {
          ///////////tunjukkan alert padam////////////
          this.popUpALert = false;
          ////send delete to API///////
          if (this.$refs.form.validate()) {
            const res = await axios.post(
              `${process.env.VUE_APP_API_URL}/PERBELANJAAN/PERBELANJAAN/delete`,
              {
                HID: this.HID,
                NOAIR: this.NOAIR,
              }
            );
            this.res = res.data;
            this.successDialog = true;
            setTimeout(() => (this.successDialog = false), 2000);
            this.successMessage = "Data Deleted!";
            this.saveButton = false;
            this.updateButton = true;
            this.reset();
            this.getData();
          } else {
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = "Please Fill In the field";
          }
        } catch (error) {
          //console.log(error)
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 2000);
          this.errMessage = "Padam : " + error;
        }
      } else if (val == 2) {
        this.popUpALert = false;
      }
    },

    async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "PERBELANJAAN"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 1000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
    },

    async getData() {
      //dapatkan data dari table z based on HID
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/PERBELANJAAN?HID=`+this.HID+`&NOAIR=`+this.NOAIR,{
          });
        var dataz = res.data.data;
        this.dataPerbelanjaan = dataz;
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

    handleClick(row) {
      this.butangSimpan = false;
      this.butangKemaskini = true;

      this.HID = row.HID;
      this.NOAIR = row.NOAIR;
      this.A01 = row.A01;
      this.A02 = row.A02;
      this.A03 = row.A03;
      this.A04 = row.A04;
      this.A05 = row.A05;
      this.A06 = row.A06;
      this.A07 = row.A07;
      this.A08 = row.A08;
      this.A09 = row.A09;
      this.A10 = row.A10;
      this.A11 = row.A11;
      this.A12 = row.A12;
      this.A13 = row.A13;
      this.A90 = row.A90;
      this.jumBelanjaA = row.jumBelanjaA;

      // or just do something with your current clicked row item data
      console.log(row);
    },

    goTo() {
      this.$router.push({ name: "PERBELANJAAN" });
    },
    goBack() {
      this.$router.push({ name: "JRH" });
    },
    kirajumBelanjaA() {
      var total = 0;
      total =
        Number(this.A01) +
        Number(this.A02) +
        Number(this.A03) +
        Number(this.A04) +
        Number(this.A05) +
        Number(this.A06) +
        Number(this.A07) +
        Number(this.A08) +
        Number(this.A09) +
        Number(this.A10) +
        Number(this.A11) +
        Number(this.A12) +
        Number(this.A13) +
        Number(this.A90);
      this.jumBelanjaA = total;
    },
    goToBorang(val) {
      var selectedSektor = val.id;
      if (selectedSektor == 1) {
        this.$router.push({ name: "hk2" });
      }
      if (selectedSektor == 2) {
        this.$router.push({ name: "hk3" });
      }
      if (selectedSektor == 3) {
        this.$router.push({ name: "hk4" });
      }
      if (selectedSektor == 4) {
        this.$router.push({ name: "hk5" });
      }
      if (selectedSektor == 5) {
        this.$router.push({ name: "hk6" });
      }
    },
    isNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  watch:{
    dataPerbelanjaan(){
      if(this.dataPerbelanjaan.length > 0){
        this.butangSimpan = false;
        //this.disabledInput = true;
      }else{
        this.butangSimpan = true;
       // this.disabledInput = false;
      }
    }
  
  },
  computed: {
    jumBelanjaA: function () {
      var total = 0;
      total =
        Number(this.A01) +
        Number(this.A02) +
        Number(this.A03) +
        Number(this.A04) +
        Number(this.A05) +
        Number(this.A06) +
        Number(this.A07) +
        Number(this.A08) +
        Number(this.A09) +
        Number(this.A10) +
        Number(this.A11) +
        Number(this.A12) +
        Number(this.A13) +
        Number(this.A90);
      return total;
    },
  },
};
</script>

<style>
#app {
  background: url("~@/assets/HIES.jpg") no-repeat center center fixed !important;
  background-size: cover;
}
</style>